module.exports = __webpack_public_path__ + "media/images/icon__infoBox--rb-gray-980c2c4cd4d4e4e2d3da2f9f97ba282a.png";